// extracted by mini-css-extract-plugin
module.exports = {"unsavedChanges":"UnsavedChanges_unsavedChanges__24TZo","unsavedChangesInfo":"UnsavedChanges_unsavedChangesInfo__1Mjxq"};